<div class="platformer-wrap">
    <div id="game-area">

    </div>
</div>